import React, { FC, memo, useEffect, useState } from 'react';

import { InputProps } from 'src/Input/Input';

import { Input } from '../Input';

interface InputWithValidationsBaseProps {
  error?: string;
  formIsSubmitted?: boolean;
  rootClass?: string;
}
export type InputWithValidationsProps = Partial<InputWithValidationsBaseProps> & Omit<InputProps, 'type'>;

export const InputWithValidations: FC<InputWithValidationsProps> = props => {
  const { formIsSubmitted, error, rootClass, ...otherProps } = props;

  const [touched, setTouched] = useState<boolean>(false);

  useEffect(() => {
    setTouched(!!formIsSubmitted);
  }, [formIsSubmitted]);

  const handleBlur = () => {
    setTouched(true);
  };

  return <Input error={touched && error} onBlur={handleBlur} rootClass={rootClass} {...otherProps} />;
};

export default memo(InputWithValidations);
